exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".zan-popup-1{width:100%;height:200px}.zan-popup-2{width:100%;line-height:44px;background-color:rgba(0,0,0,.701961);text-align:center;color:#fff}.zan-popup-3{width:100%;height:100%;background-color:#fff}.zan-popup-4{width:50%;height:200px;background:#fff;border-radius:10px}.page-popup .zan-button-1{margin-bottom:10px}.page-sub-title{padding:20px 15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-703eae7e!./~/vue-loader/lib/selector.js?type=styles&index=0!./docs/examples/popup.vue
// module id = 233
// module chunks = 0